import { Icon } from '@/components/entities/Sprite';
import { MARKET } from '@/libs/market/market';
import { useUserMeQuery } from '@/queries/user/user.queries';
import { cn } from '@/utils/cn';
import { DESKTOP_SECOND_BLOCK_ICONS, MOBILE_SECOND_BLOCK_ICONS, PAYMENT_ICONS } from '../consts/paymentIcons';

const CANADA_EXCLUDED_PAYMENT_ICON_NAMES = new Set(['footer-pay-pal', 'footer-cash-app']);

const PaymentBlock = () => {
  const { data: user } = useUserMeQuery();
  const isCanada = user?.market === MARKET.CA;

  const paymentIcons = isCanada
    ? PAYMENT_ICONS.filter(icon => !CANADA_EXCLUDED_PAYMENT_ICON_NAMES.has(icon.name))
    : PAYMENT_ICONS;
  // CA doesn't support PayPal, CashApp or Crypto yet, so both second-block groups are empty there.
  const mobileSecondBlockIcons = isCanada ? [] : MOBILE_SECOND_BLOCK_ICONS;
  const desktopSecondBlockIcons = isCanada ? [] : DESKTOP_SECOND_BLOCK_ICONS;

  return (
    <div
      className={cn(
        'flex flex-col xxl:flex-row justify-start items-center relative xxl:gap-21.25 3xl:justify-center max-xl:mt-0.25',
        isCanada && 'xxl:justify-center',
      )}
    >
      <div
        className={cn(
          'flex items-center justify-center gap-3 lg:gap-21.25 3xl:ml-55 lg:ml-[0.5313rem]',
          isCanada && 'lg:ml-0 3xl:ml-0',
        )}
      >
        {paymentIcons.map((icon, index) => (
          <Icon
            name={icon.name}
            key={icon.name}
            className={cn('size-15 md:size-18', index >= 4 && 'hidden xxl:block')}
          />
        ))}
      </div>
      {mobileSecondBlockIcons.length > 0 && (
        <div className="flex items-center justify-center gap-2 -mt-3.5 xxl:hidden">
          <div className="grid grid-flow-col auto-cols-max items-center gap-3">
            {mobileSecondBlockIcons.map(icon => (
              <Icon name={icon.name} key={icon.name} className="size-15 text-white" />
            ))}
          </div>
          <p className="font-medium text-white leading-[120%] text-sm -mb-0.25">Crypto</p>
        </div>
      )}
      {desktopSecondBlockIcons.length > 0 && (
        <div className="hidden xxl:flex gap-3">
          {desktopSecondBlockIcons.map(icon => (
            <Icon name={icon.name} key={icon.name} className="size-8 text-main-800" />
          ))}
        </div>
      )}
    </div>
  );
};
export default PaymentBlock;
